import { render } from "./addCustorm.vue?vue&type=template&id=a9916360&scoped=true"
import script from "./addCustorm.vue?vue&type=script&lang=js"
export * from "./addCustorm.vue?vue&type=script&lang=js"

import "@/assets/css/add.css?vue&type=style&index=0&id=a9916360&scoped=true&lang=css&external"
import "./addCustorm.vue?vue&type=style&index=1&id=a9916360&scoped=true&lang=css"
import "./addCustorm.vue?vue&type=style&index=2&id=a9916360&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a9916360"]])

export default __exports__